import React, {Component} from 'react';
import {formatTime} from "../../../utils";
class InterviewTime extends Component {
    render() {
        let {text, record} = this.props;
        let endTime;
        if(record.endTime){
            endTime = record.endTime
        }
        return  <div style={{display:"flex",overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap",alignItems:"center"}}>
            {text?<div><span>{text?formatTime(text):null}</span> ~ <span>{endTime?formatTime(endTime):null}</span></div>:'-'}
        </div>

    }
}

export default InterviewTime;
